import {useEffect, useState} from 'react';
import classNames from './search-bar.module.css';
import {useTranslation} from 'react-i18next';

interface SearchProps {
  setSearchTerm?: (v) => void;
  searchTerm?: any;
  refreshFlag?: any;
}

const SearchBar = ({searchTerm, setSearchTerm, refreshFlag}: SearchProps) => {
  const {t} = useTranslation();
  const [searchVal, setsearchVal] = useState('');

  useEffect(() => {
    setsearchVal(searchTerm);
  }, [refreshFlag]);

  return (
    <>
      <div id={'search-bar'} className={classNames['search-bar-container']}>
        <div className={classNames['search-sub-container']}>
          <div>
            <input
              className={classNames['search-input']}
              placeholder={t('Side_Menu_Search Job')}
              value={searchVal}
              onChange={(e) => {
                if (e.target.value) {
                  setsearchVal(e.target.value);
                } else if (!e.target.value) {
                  setSearchTerm('');
                  setsearchVal('');
                }
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  setSearchTerm(searchVal);
                }
              }}
            />
          </div>
          <div className={classNames['search-bar-btn-dev']}>
            <button
              className={classNames['search-bar-button']}
              onClick={() => setSearchTerm(searchVal)}
            >
              {t('Search')}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default SearchBar;
